import { Link } from 'react-router-dom';

export default function BlogIndex() {
  const articles = [
    {
      id: 22,
      title: 'How Installers Ensure TVs Are Level, Secure, and Safe',
      excerpt: 'A professional TV installation involves more than attaching a bracket to the wall. Installers follow a series of checks to ensure the screen is level, securely fixed, and safe for long-term use.',
      slug: 'how-installers-ensure-tvs-are-level-secure-and-safe',
      image: 'https://public.readdy.ai/ai/img_res/a822c538f79b591b63b4616d894174a8.jpg'
    },
    {
      id: 23,
      title: 'What Goes Into a High-Quality TV Installation',
      excerpt: 'High-quality TV installations are defined by planning, precision, and attention to long-term use. Rather than focusing solely on speed, professionals prioritise correct placement and secure mounting.',
      slug: 'what-goes-into-a-high-quality-tv-installation',
      image: 'https://readdy.ai/api/search-image?query=A%20clean%20Australian%20living%20room%20with%20a%20professionally%20installed%20wall-mounted%20TV%20showing%20hidden%20cables%20and%20neat%20cable%20management.%20The%20room%20features%20neutral%20tones%2C%20comfortable%20seating%2C%20and%20realistic%20interior%20photography.%20The%20TV%20is%20perfectly%20centered%20on%20the%20wall%20with%20no%20visible%20wires%2C%20demonstrating%20professional%20installation%20quality%20in%20a%20modern%20Australian%20home.&width=800&height=500&seq=article23&orientation=landscape'
    },
    {
      id: 24,
      title: 'TV Installation Considerations for Australian Homes',
      excerpt: 'Australian homes vary widely in construction style, age, and layout, which influences how TV installations are planned. From older brick homes to modern apartments, each setting presents different considerations.',
      slug: 'tv-installation-considerations-for-australian-homes',
      image: 'https://readdy.ai/api/search-image?query=An%20Australian%20home%20interior%20showing%20a%20wall-mounted%20TV%20installed%20in%20a%20versatile%20room%20layout.%20The%20scene%20demonstrates%20different%20architectural%20styles%20from%20brick%20walls%20to%20modern%20plaster%2C%20clean%20and%20organized%20setup.%20Realistic%20photography%20showing%20the%20adaptability%20of%20TV%20mounting%20across%20various%20Australian%20home%20construction%20types%20with%20natural%20lighting.&width=800&height=500&seq=article24&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <Link to="/" className="inline-block">
            <img 
              src="https://public.readdy.ai/ai/img_res/994872d3-d12a-41a9-b9a3-399c87796801.png" 
              alt="Practical Living Projects" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-5xl font-serif font-bold text-gray-900 mb-4">Practical Living Projects</h1>
        <p className="text-xl text-gray-600 mb-16">Insights on professional home installations and improvements</p>

        {/* Articles List */}
        <div className="space-y-12">
          {articles.map((article) => (
            <article key={article.id} className="group">
              <Link to={`/blog/${article.slug}`} className="block">
                <div className="mb-6 overflow-hidden rounded-lg">
                  <div className="w-full h-80 relative">
                    <img 
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                </div>
                <h2 className="text-3xl font-serif font-bold text-gray-900 mb-3 group-hover:text-gray-600 transition-colors cursor-pointer">
                  {article.title}
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {article.excerpt}
                </p>
                <span className="inline-block mt-4 text-base font-medium text-gray-900 group-hover:text-gray-600 transition-colors cursor-pointer">
                  Read article →
                </span>
              </Link>
            </article>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-24">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <p className="text-sm text-gray-500 text-center">
            © 2025 Practical Living Projects. <a href="https://readdy.ai/?origin=logo" className="hover:text-gray-700 transition-colors whitespace-nowrap cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
